export default __webpack_public_path__ + "static/tomaten-lijn-6f6fe998eef5f9122d5c0aee2446970a.png";